import { render } from "./shuimu.vue?vue&type=template&id=f48f6c10"
import script from "./shuimu.vue?vue&type=script&lang=js"
export * from "./shuimu.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__